import { schema } from 'normalizr';

export const SCHEMA_TYPE_AI_TOOLS = 'aiTools';
export const SCHEMA_TYPE_AI_TOOL_RECEIPTS = 'aiToolReceipts';
export const SCHEMA_TYPE_AI_TOOL_PACKAGES = 'aiToolPackages';
export const SCHEMA_TYPE_AI_TOOL_POLICIES = 'aiToolPolicies';
export const SCHEMA_TYPE_AI_TOOL_RATE_LIMITS = 'aiToolRateLimits';
export const SCHEMA_TYPE_AI_TOOLSET_EXPORTS = 'aiToolsetExports';

// Tool Receipt schema
export const aiToolReceiptSchema = new schema.Entity(
  SCHEMA_TYPE_AI_TOOL_RECEIPTS,
  {},
  {
    idAttribute: 'id',
  },
);

// Main Tool schema (versionless)
export const aiToolSchema = new schema.Entity(
  SCHEMA_TYPE_AI_TOOLS,
  {},
  {
    // Handle both 'id' (from tools list) and 'tool_id' (from toolset detail response)
    idAttribute: (value: any) => value.id || value.tool_id,
  },
);

// Toolset Export schema (defined before aiToolPackageSchema to use in it)
export const aiToolsetExportSchema = new schema.Entity(
  SCHEMA_TYPE_AI_TOOLSET_EXPORTS,
  {},
  {
    idAttribute: (value: any) => value.export_id || value.id,
  },
);

// Tool Package (Toolset) schema
export const aiToolPackageSchema = new schema.Entity(
  SCHEMA_TYPE_AI_TOOL_PACKAGES,
  {
    tools: [aiToolSchema],
    exports: [aiToolsetExportSchema],
  },
  {
    idAttribute: (value: any) =>
      value.id || value.tool_set_id || value.toolset_id || value.toolset_fk,
  },
);

// Policy schema
export const aiToolPolicySchema = new schema.Entity(
  SCHEMA_TYPE_AI_TOOL_POLICIES,
  {},
  {
    idAttribute: 'id',
  },
);

// Rate Limit schema
export const aiToolRateLimitSchema = new schema.Entity(
  SCHEMA_TYPE_AI_TOOL_RATE_LIMITS,
  {},
  {
    idAttribute: 'id',
  },
);

export default aiToolSchema;
